import gql from 'graphql-tag';

import dokkioTagFragment from './dokkioTagFragment';
import integrationItemFragment from './integrationItemFragment';
import suggestedDokkioLabelFragment from './suggestedDokkioLabelFragment';
import suggestedDokkioTagFragment from './suggestedDokkioTagFragment';
import suggestedIntegrationItemDokkioTagFragment from './suggestedIntegrationItemDokkioTagFragment';
import suggestedWebpageDokkioTagFragment from './suggestedWebpageDokkioTagFragment';
import suggestedWebpageSuggestedDokkioTagFragment from './suggestedWebpageSuggestedDokkioTagFragment';

export const suggestionFragment = gql`
  fragment suggestionFragment on Suggestion {
    suggestionType
    dokkioClass
    suggestionID
    confidence
    suggestedIntegrationItemDokkioTag {
      ...suggestedIntegrationItemDokkioTagFragment
      integrationItem {
        ...integrationItemFragment
      }
      dokkioTag {
        ...dokkioTagFragment
      }
    }
    suggestedDokkioTag {
      ...suggestedDokkioTagFragment
    }
    suggestedDokkioLabel {
      ...suggestedDokkioLabelFragment
    }
    suggestedWebpageDokkioTag {
      ...suggestedWebpageDokkioTagFragment
      dokkioTag {
        ...dokkioTagFragment
      }
    }
    suggestedWebpageSuggestedDokkioTag {
      ...suggestedWebpageSuggestedDokkioTagFragment
      suggestedDokkioTag {
        ...suggestedDokkioTagFragment
      }
    }
  }
  ${dokkioTagFragment}
  ${integrationItemFragment}
  ${suggestedDokkioLabelFragment}
  ${suggestedDokkioTagFragment}
  ${suggestedIntegrationItemDokkioTagFragment}
  ${suggestedWebpageDokkioTagFragment}
  ${suggestedWebpageSuggestedDokkioTagFragment}
`;
export default suggestionFragment;
